var React = require('react');

function Bubblebox (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector 418","d":"M16.0008 8.93932V0H0L0.974159 0.0974159C3.57761 0.357761 6.01084 1.51075 7.86102 3.36077L14.1902 9.68937C14.3891 9.88826 14.6588 10 14.9401 10C15.5259 10 16.0008 9.52512 16.0008 8.93932Z","fill":"#1C2841"}));
}

Bubblebox.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Bubblebox;

Bubblebox.default = Bubblebox;
